var map = {
	"./marker-appointment-late.png": 1858,
	"./marker-appointment.png": 808,
	"./marker-appointment_notified-late.png": 1859,
	"./marker-appointment_notified.png": 809,
	"./marker-issue-late.png": 1860,
	"./marker-issue.png": 810,
	"./marker-late.png": 1861,
	"./marker-reject-late.png": 1862,
	"./marker-reject.png": 1863,
	"./marker-valid-late.png": 1864,
	"./marker-valid.png": 1865,
	"./marker-waiting-late.png": 1866,
	"./marker-waiting.png": 811
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1857;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/marker\-.*\.png$
// module id = 1857
// module chunks = 0